// extracted by mini-css-extract-plugin
export default {"input":"MyInputForm_input__lIEgR","error":"MyInputForm_error__QY8Sm","inputWrapper":"MyInputForm_inputWrapper__CcP1P"};